module.exports = __webpack_public_path__ + "static/media/mask7.53725848.JPG";